import React from "react";
import { ReactComponent as ComboChartIcon } from "assets/icons/combo_chart.svg";
import { ReactComponent as MultiportalPresenceIcon } from "assets/icons/multiportal_presence.svg";
import { ReactComponent as LocationIntelligence } from "assets/icons/location_intelligence.svg";
import searchPage from "assets/images/3rd.webp";
import RevealAnimationSection from "components/Animation/RevealAnimationSection";
import useDialog from "hooks/useDialog";
import useAuth from "hooks/useAuth";

const ResearchComparatorSection = () => {
  const { openSignupDialog } = useDialog();
  const { user } = useAuth();

  return (
    <div className="py-[40px] overflow-hidden lg:py-[75px] bg-[#f5f5f5] px-5">
      <RevealAnimationSection direction="right">
        {/* mobile heading  */}
        <h1 className="leading-normal lg:hidden mb-[25px] text-center font-bold text-[30px] ">
          Il <span className="text-primary">Comparatore</span> per la ricerca
        </h1>
        <div className="flex items-center justify-center flex-col-reverse lg:flex-row space-y-5 lg:space-y-0">
          <div className="lg:w-[50%] w-full">
            <div className="lg:max-w-[87%] flex items-center lg:items-start flex-col">
              {/* dasktop heading  */}
              <h1 className="leading-[48.41px] hidden lg:block font-bold text-[40px] ">
                Il <span className="text-primary">Comparatore</span> per la
                ricerca
              </h1>
              <p className="text-[14px] lg:text-start text-center font-normal leading-[24px] lg:leading-[28px] mt-[25px] lg:mt-[18px]">
                Basta navigare tra i portali immobiliari. HouseScan scannerizza
                in automatico tra centinaia di portali e siti di annunci
                immobiliari e aggrega i risultati della ricerca in un unico
                posto.
              </p>
              <div className="mt-[20px] hidden lg:block">
                <div className="flex items-start space-x-[7px]">
                  <ComboChartIcon />
                  <div>
                    <h4 className="text-[16px] leading-[28px] font-bold">
                      Storicità dell’annuncio
                    </h4>
                    <p className="text-[14px] font-normal leading-[28px]">
                      Scopri la storia completa di ogni annuncio, monitora da
                      quanto tempo è presente sul mercato tracciando eventuali
                      variazioni di prezzo
                    </p>
                  </div>
                </div>
                <div className="flex items-start space-x-[7px] mt-[25px]">
                  <MultiportalPresenceIcon className="mt-[6px]" />
                  <div>
                    <h4 className="text-[16px] leading-[28px] font-bold">
                      Presenza Multiportale{" "}
                    </h4>
                    <p className="text-[14px] font-normal leading-[28px]">
                      Per ogni annuncio vengono visualizzati i portali su cui
                      l'annuncio è stato pubblicato e i relativi prezzi
                    </p>
                  </div>
                </div>
                <div className="flex items-start space-x-[7px] mt-[25px]">
                  <LocationIntelligence className="mt-1" />
                  <div>
                    <h4 className="text-[16px] leading-[28px] font-bold">
                      Location Intelligence{" "}
                    </h4>{" "}
                    <p className="text-[14px] font-normal leading-[28px]">
                      Utilizza l’intelligenza artificiale per ottenere info sui
                      servizi disponibili nelle vicinanze, e capire la logistica
                      urbana degli spostamenti
                    </p>
                  </div>
                </div>
              </div>
              {!user && (
                <button
                  onClick={openSignupDialog}
                  className="lg:mt-5 mt-[25px] shadow-sm w-[154px] lg:w-[247px] h-[47px] lg:h-[55px] flex items-center justify-center border-[1px] border-[#4AB4F5] hover:bg-transparent rounded-[4px] font-semibold hover:text-primary text-[14px] bg-[#1DA1F2] text-white transition-all duration-400 ease-linear"
                >
                  ISCRIVITI
                </button>
              )}
            </div>
          </div>
          <img
            className="h-full lg:w-[50%] w-full"
            src={searchPage}
            alt="Search Page"
          />
        </div>
      </RevealAnimationSection>
    </div>
  );
};

export default ResearchComparatorSection;
